module.exports = __webpack_public_path__ + "img/ico_device_pc.617279db.svg";